import { render, staticRenderFns } from "./JustifiedTabs.vue?vue&type=template&id=11d17908"
import script from "./JustifiedTabs.vue?vue&type=script&lang=js"
export * from "./JustifiedTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports